





import { Component, Vue } from 'vue-property-decorator'
import { Meta, Hook } from '@/helpers/decorators'

export default class Reports extends Vue {
  @Meta
  metas() {
    return {
      title: this.$t('menu.reports'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }
}
